module.exports = __webpack_public_path__ + "img/words10.5a3e3ebc.png";